export default __webpack_public_path__ + "static/media/Wurus_Dark.8ef51c0a.png";